import React from "react";
import Button, { ButtonSizes, ButtonThemes } from "ui-components/button/button";

interface ActionSectionProps {
  handleClear: () => void;
  handleSave: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  spinner?: boolean;
  className?: string;
  disabled?: boolean;
}

const ActionSection: React.FC<ActionSectionProps> = ({
  handleClear,
  handleSave,
  primaryButtonText = "Save",
  secondaryButtonText = "Clear",
  className,
  disabled = false,
  spinner = false,
}) => {
  return (
    <div className="form-action">
      <Button
        type="button"
        theme={ButtonThemes.gray}
        onClick={handleClear}
        className={`${className || ""} mr-05`}
        size={ButtonSizes.small}
      >
        {secondaryButtonText}
      </Button>
      <Button
        type="button"
        theme={ButtonThemes.blue}
        onClick={() => {
          if (disabled || spinner) return;
          handleSave();
        }}
        className={className}
        size={ButtonSizes.small}
        disabled={disabled || spinner}
        spinner={spinner}
      >
        {primaryButtonText}
      </Button>
    </div>
  );
};

export default ActionSection;
